var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCouple = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 6,
  cy: 4,
  r: 2
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 18,
  cy: 4,
  r: 2
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M10 15v-5a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v5M22 15l-.877-6.141a1 1 0 0 0-.99-.859h-4.266a1 1 0 0 0-.99.859L14 15M4 16v6.417M8 16v6.417M16 16v6.417M20 16v6.417"
})));
SvgCouple.viewBox = '0 0 24 24';
const ForwardRef = /*#__PURE__*/forwardRef(SvgCouple);
export default ForwardRef;